import { render, staticRenderFns } from "./SanityImage.vue?vue&type=template&id=2139d829"
import script from "./SanityImage.vue?vue&type=script&lang=js"
export * from "./SanityImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports